import { createAction, props } from '@ngrx/store';

export const setHelpVisible = createAction(
  '[Help] Update help state in store',
  props<{ helpVisible: boolean }>()
);

export const registerPageGuide = createAction(
  '[Help] Register a page guide for the current page'
);

export const unregisterPageGuide = createAction(
  '[Help] Unregister a page guide for the current page'
);

export const setOnBoardingEnabled = createAction(
  '[Help] Update onboarding wizard state in store',
  props<{ onBoardingEnabled: boolean }>()
);
